import script from "./InputSelectorCantidad.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSelectorCantidad.vue?vue&type=script&setup=true&lang=js"

import "./InputSelectorCantidad.vue?vue&type=style&index=0&id=b6c44128&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6c44128"]])

export default __exports__